
import { FormControl, useTheme, useMediaQuery, Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const DeliveryCountrySelectorComponent = ({ deliveryCountry, countries, handleChange, blackStyle, fullWidth = false }) => {
    const { t } = useTranslation()
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));


    return (
        <FormControl variant="outlined" fullWidth={fullWidth}>
            <Autocomplete
                sx={{
                    border: '1px solid',
                    borderColor: (isSmallScreen || blackStyle) ? '#000' : '#fff',
                    '& .MuiFormLabel-root,.MuiInputBase-input': {
                        color: (isSmallScreen || blackStyle) ? '#000' : '#fff',
                        fontWeight: "bold"
                    }
                }}
                disablePortal
                options={countries.map((val) => ({
                    label: val.name,
                    value: val.name
                }))}
                value={deliveryCountry}
                onChange={(event, newValue) => {
                    handleChange(newValue?.value)
                    window.location.reload()
                }}
                renderInput={(params) => (
                    <TextField {...params} label={t("deliveryCountry")} variant="outlined" />
                )}
                disableClearable={true}
            />
        </FormControl>
    );
};